import { render } from "./loginPage.vue?vue&type=template&id=2436f67a"
import script from "./loginPage.vue?vue&type=script&lang=js"
export * from "./loginPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\dmart\\Desktop\\Mi codigo\\Dootaclient\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__